import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { notifyError, notifySuccess } from "../../utils/functions";

const BetaTesterModal = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    console.log("Submitted email:", email);

    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/beta/tester/create`;
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apikey: process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          email: email,
        }),
      });

      if (!response.ok) {
        throw new Error("failed! Check again.");
      }

      const data = await response.json();
      notifySuccess(data.message);
      setTimeout(() => onClose(), 2000);
    } catch (error) {
      notifyError(error?.message || "Failed to submit beta tester.");
    }
  };

  return (
    <div className="beta-modal-overlay">
      <div className="beta-modal">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>

        <div className="icon-container">
          <Icon icon="mdi:bell-outline" className="bell-icon" />
        </div>

        <h2>Looking For Beta Testers</h2>
        <p>
          Join our exclusive beta program and help shape the future of fitness
          discovery. Get early access to Circuit!
        </p>
        <form onSubmit={handleSubmit} className="email-form">
          <div className="input-wrapper">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className="send-btn">
              <Icon icon="mdi:send" />
            </button>
          </div>
          {error && <span className="error-msg">{error}</span>}
        </form>
      </div>
    </div>
  );
};

export default BetaTesterModal;
